'use client'

import { type FC, useMemo } from 'react'
import { JsonLd } from 'react-schemaorg'
import { type BreadcrumbList, type ListItem } from 'schema-dts'

export type SeoBreadcrumbListItem = Pick<ListItem, 'item' | 'name'>

/**
 * Only string `name` and URL `item` (except the last item https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#list-item) are required,
 * the rest is provided by `SeoBreadcrumbListJsonLd` component
 */
export type SeoBreadcrumbListItems = SeoBreadcrumbListItem[]

type SeoBreadcrumbListJsonLdProps = {
  breadcrumbs?: SeoBreadcrumbListItems | null
}

export const SeoBreadcrumbListJsonLd: FC<SeoBreadcrumbListJsonLdProps> = ({
  breadcrumbs,
}) => {
  const itemListElement = useMemo(
    () =>
      (breadcrumbs ?? []).map<ListItem>((listItem, index) => ({
        ...listItem,
        '@type': 'ListItem',
        position: index + 1,
      })),
    [breadcrumbs],
  )

  return (
    <JsonLd<BreadcrumbList>
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
      }}
    />
  )
}
